/* Abre el formulario real de Judge.me sin publicar ni enviar ninguna opinión. */
document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[data-vc-write-review]');
  if (!trigger) return;
  var status = document.getElementById('vc-review-status');
  var attempts = 0;
  trigger.disabled = true;
  function openReview() {
    var nativeButton = document.querySelector('#judgeme_product_reviews [data-testid="write-review-button"], #judgeme_product_reviews .jdgm-write-rev-link');
    if (nativeButton) {
      nativeButton.click();
      trigger.disabled = false;
      if (status) status.hidden = true;
      return;
    }
    if (status) {
      status.hidden = false;
      status.textContent = attempts < 40 ? 'Estamos cargando el formulario de reseñas…' : 'No pudimos abrir el formulario. Intenta nuevamente o escríbenos desde Contacto.';
    }
    if (++attempts <= 40) setTimeout(openReview, 250);
    else trigger.disabled = false;
  }
  openReview();
});
